import React, { memo, useEffect, useState } from "react";
import { Link } from 'react-router';

import { ROUTES, SECTION_IDS, buildGalleryAlbumRoute } from '../../constants/routes';
import { fetchGalleryAlbums } from '../../services/galleryService';

const AlbumSkeleton = () => (
    <div className="gallery-album-card gallery-album-skeleton" aria-hidden="true">
        <div className="gallery-album-img-wrap skeleton-img" />
        <div className="gallery-album-info">
            <div className="skeleton-line skeleton-line-title" />
            <div className="skeleton-line skeleton-line-meta" />
        </div>
    </div>
);

export const Gallery = memo(() => {
    const [teaserAlbums, setTeaserAlbums] = useState([]);
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        let isMounted = true;

        fetchGalleryAlbums()
            .then((albums) => {
                if (!isMounted) return;
                const latest = Array.isArray(albums) ? albums.slice(0, 2) : [];
                setTeaserAlbums(latest);
                setStatus(latest.length > 0 ? 'ready' : 'empty');
            })
            .catch(() => {
                if (isMounted) setStatus('error');
            });

        return () => { isMounted = false; };
    }, []);

    return (
        <div id={SECTION_IDS.GALLERY} className="text-center">
            <div className="container">
                <div className="section-title">
                    <h2>Galerie</h2>
                    <p>Highlights aus Turnieren, Trainings und Community-Events.</p>
                </div>

                <div className="gallery-album-grid" data-testid="home-gallery-grid">
                    {status === 'loading' && (
                        <div data-testid="home-gallery-loading" style={{ display: 'contents' }}>
                            <AlbumSkeleton />
                            <AlbumSkeleton />
                            <AlbumSkeleton />
                        </div>
                    )}

                    {status === 'ready' && teaserAlbums.map((album) => (
                        <Link
                            key={album.id}
                            to={buildGalleryAlbumRoute(album.id)}
                            className="gallery-album-card"
                        >
                            <div className="gallery-album-img-wrap">
                                {album.coverPhoto ? (
                                    <img
                                        data-testid="home-gallery-thumbnail"
                                        src={album.coverPhoto.thumbUrl || album.coverPhoto.fullUrl}
                                        alt={album.coverPhoto.caption || album.title}
                                        loading="lazy"
                                    />
                                ) : (
                                    <div className="gallery-album-no-cover" aria-hidden="true">📷</div>
                                )}
                                <div className="gallery-album-overlay" aria-hidden="true" />
                            </div>
                            <div className="gallery-album-info">
                                <span className="gallery-album-title">{album.title}</span>
                                {album.photoCount > 0 && (
                                    <span className="gallery-album-count">{album.photoCount} Fotos</span>
                                )}
                            </div>
                        </Link>
                    ))}

                    {(status === 'error' || status === 'empty') && (
                        <div className="gallery-state-box gallery-empty-box" data-testid="home-gallery-placeholder">
                            <span className="gallery-state-icon">📷</span>
                            <p>Bald findest du hier wieder frische Eindrücke.</p>
                        </div>
                    )}
                </div>

                <div className="gallery-teaser-cta">
                    <Link
                        to={ROUTES.GALLERY}
                        className="btn btn-custom btn-lg"
                        data-testid="home-gallery-cta"
                    >
                        Zur Galerie →
                    </Link>
                </div>
            </div>
        </div>
    );
});

Gallery.displayName = 'Gallery';
